<template>
    <div class="informDetailList">
        <van-sticky :offset-top="topHeight-10">
            <div class="title ben-border-t">
                <van-row class="">
                    <van-col span="8" class="title-left">
                        <span class="ben-000-color ben-size-15 ben-text-bold ">产品信息</span>
                    </van-col>
                    <van-col span="16" class="ben-text-bold ben-333-color ben-size-12 title-right" v-if="tatalPrice>0"> 
                        <div class="title-right-comm">
                        <i class="el-icon-coin"></i>总报价 :
                        <span class="ben-size-12 ben-c41335-color">￥</span>
                        <span class="ben-size-14 ben-c41335-color">{{utils.num_format(tatalPrice)}}</span>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </van-sticky>
        <div class="infom-list">
            <div class="list-comm" v-for="(comm,index) in list" :key="index">
                <van-row class="">
                    <van-col span="18" class="mas-l ben-text-bold ben-000-color ben-size-13 ben-ell-2">{{comm.goods_name}}</van-col>
                    <van-col span="6" class="mas-r ben-size-12 ben-align-right"> 
                        <span v-if="comm.tails&&comm.tails.wantOfferDetail" class="ben-80c-color">已报价</span>
                        <span v-else class="ben-be-color">未报价</span>
                    </van-col>
                    <van-col span="9" class="mas-num ben-80-color ben-size-12"> 数量: {{comm.buy_num}} {{comm.unit}} </van-col>
                    <van-col span="15" class="mas-num ben-80-color ben-size-12 ben-align-right" v-if="comm.tails.wantOfferDetail"> 产品报价 : 
                        <span class="ben-c41335-color  ben-text-bold ben-size-12"> ￥</span>
                        <span class="ben-c41335-color  ben-text-bold ben-size-14">{{utils.num_format(parseFloat(comm.tails.wantOfferDetail.offer_unit_price)/100*comm.buy_num,0)}}</span>
                        <span class="ben-c41335-color  ben-text-bold ben-size-12">
                            .{{setTargetUnitPriceLast(parseFloat(comm.tails.wantOfferDetail.offer_unit_price)*comm.buy_num)}}</span>
                    </van-col>
                </van-row>
            </div>
            <div class="load-more ben-align-center ben-c41335-color" v-if="list.length<allList.length" @click="loadMore">
                <div class="mohu"></div>
                <p class="ben-size-12">点击查看更多</p>
                <p><van-icon name="arrow-down"  class="ben-text-bold"/></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'informDetailList',
    props : {
        data : {
            type : Object
        },
        topHeight : {
            type :Number
        }
    },
    components: {
    },
    data () {
        return {
            list : [],
            allList  : [],
            pageNum : 1,
            num : 20,
            targeUnitPrice : "",
            targeUnitPricelast : "",
            tatalPrice : 0
        }
    },
    created () {
        
    },
    methods: {
        setTargetUnitPriceLast(val){
            let targeUnitPriceLast = "";
            let targeUnitPrice = this.utils.num_format(parseFloat(val)/100,2)
            targeUnitPriceLast = targeUnitPrice.substring(targeUnitPrice.length-2)
            return targeUnitPriceLast
        },
        loadMore(){
            this.pageNum+=1;
            this.list = this.list.concat(this.allList.slice((this.pageNum-1)*20,this.pageNum*20))
        },
        tatalPriceFun(){
            let priceCount = 0
            this.allList.forEach((item,index)=>{
                if(item.tails.wantOfferDetail){
                    priceCount += (parseFloat(item.tails.wantOfferDetail.offer_unit_price)/100 * parseInt(item.buy_num))
                }
            })
            this.tatalPrice = priceCount
        }
    },
    watch : {
        data(val,oldVal){
            this.allList = val.wantBuyAndDetails.details;
            this.list = []
            this.list = this.list.concat(this.allList.slice((this.pageNum-1)*20,this.pageNum*20))
            this.tatalPriceFun()
        }
    },
    mounted () {
         this.allList = this.data.wantBuyAndDetails.details;
            this.list = this.list.concat(this.allList.slice(0,20))
    },
}

</script>


<style lang='scss' scoped>
    .informDetailList{
        background: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        .load-more{
            // background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.24) 69%);
            position: absolute;
            bottom: 0px;
            left: 0;
            right: 0;
            margin: auto;
            p{
                background: #fff;
            }
            .mohu{
                position: relative;
                height: 40px;
                // background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
                background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.24) 69%);
            }
        }
        .infom-list{
            padding: 5px 15px;
            position: relative;
            .list-comm{
                padding: 15px;
                background: #F9F9F9;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
                margin-top: 5px;
                .mas-num{
                    margin-top: 5px;
                }
            }
        }
        .title{
            padding: 0px 15px 0px 15px;
            height: 44px;
            background: #fff;
            i{
                font-size: 16px;
                margin-right: 5px;
            }
            i::before{
                top: 2px;
            }
            .title-right{
                border-left:1px solid #EEEEEE ;
                height: 44px;
                margin-top: 0px;
                .title-right-comm{
                    margin-top: 10px;
                    margin-left: 10px;
                }
            }
            .title-left{
                
                padding-bottom: 10px;
                height: 44px;
                margin-top: 10px;
                >span{
                    border-bottom: 3px solid #C41335;
                    padding-bottom: 10px;
                }

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerDetailList.vue